<app-table
  *ngIf="cols && personId && fixedFilters"
  [cols]="cols"
  modelName="pedidos"
  sortField="dateCreated"
  [sortOrder]="1"
  [service]="shippingOrderService"
  [findPage]="findPage"
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
  [fixedFilters]="fixedFilters"
  [showTitle]="false"
  [changeColumns]="true"
/>
